/**
 * Bonzentrale — Produktbild-Galerie wie bei Amazon: Überfährt die Maus ein Vorschaubild, zeigt das Hauptbild
 * dieses Bild (Horizon wechselt sonst nur per Klick). Nur bei echter Maus; auf Touch-Geräten bleibt es bei
 * Tippen und Wischen. Der Wechsel läuft über Horizons eigenen Klick-Handler, die Galerie bleibt Horizon-Logik.
 */
const mitMaus = window.matchMedia('(hover: hover) and (pointer: fine)');

document.addEventListener(
  'pointerover',
  (event) => {
    if (!mitMaus.matches || event.pointerType !== 'mouse' || !(event.target instanceof Element)) return;
    const vorschau = event.target.closest('.product-information .slideshow-controls__thumbnail');
    if (!vorschau || vorschau.getAttribute('aria-selected') === 'true') return;
    vorschau.click();
  },
  { passive: true }
);
